import React from "react";

interface MobileMenuProps {
  isOpen: boolean;
  scrollToSection: (id: string) => void;
  handleLoginClick: () => void;
  handleSignupClick: () => void;
}

export const MobileMenu = ({ isOpen, scrollToSection, handleLoginClick, handleSignupClick }: MobileMenuProps) => {
  if (!isOpen) return null;
  
  return (
    <div className="md:hidden py-4 animate-fade-down bg-brutal-white border-4 border-brutal-black mt-2">
      <button
        onClick={() => scrollToSection('benefits')}
        className="block w-full text-left px-4 py-2 text-brutal-black hover:bg-brutal-black hover:text-brutal-white transition-colors font-mono uppercase"
      >
        Features
      </button>
      <button
        onClick={() => scrollToSection('pricing')}
        className="block w-full text-left px-4 py-2 text-brutal-black hover:bg-brutal-black hover:text-brutal-white transition-colors font-mono uppercase"
      >
        Pricing
      </button>
      <button
        onClick={() => scrollToSection('faq')}
        className="block w-full text-left px-4 py-2 text-brutal-black hover:bg-brutal-black hover:text-brutal-white transition-colors font-mono uppercase"
      >
        FAQ
      </button>
      <div className="px-4 pt-2 flex flex-col gap-2">
        <button
          className="brutal-button-secondary w-full"
          onClick={handleLoginClick}
        >
          Login
        </button>
        <button
          className="brutal-button w-full"
          onClick={handleSignupClick}
        >
          Sign Up
        </button>
      </div>
    </div>
  );
};
